export const LOGO_MAX_HEIGHT = '25px';
